import { Injectable, Inject, InjectionToken } from '@angular/core';
import { constant, noop } from 'lodash-es';

export const ESTENSA_MODULE_NOTIFICATION_SERVICE = new InjectionToken('estensa.module.notification.service');

export interface PersistentNotificationOptions {
    description: string;
    onDismiss?(): void;
    onClick?(): void;
}

export interface INotificationServiceNg1 {
    clearPersistentNotification(...ids: number[]): void;
    editPersistentNotification(id: number, options: Partial<PersistentNotificationOptions>): void;
    insertPersistentNotification(options: PersistentNotificationOptions): number;
    operationFailed(message: string): void;
    operationExecutedWithSuccess(message: string): void;
    operationExecutedWithWarning(message: string): void;
}

@Injectable()
export class NullNotificationService implements INotificationServiceNg1 {
    clearPersistentNotification = noop;
    editPersistentNotification = noop;
    insertPersistentNotification = constant(0);
    operationExecutedWithSuccess = noop;
    operationExecutedWithWarning = noop;
    operationFailed = noop;
}

@Injectable({
    providedIn: 'root',
})
export class EstensaNotificationService {
    constructor(@Inject(ESTENSA_MODULE_NOTIFICATION_SERVICE) private notificationService: INotificationServiceNg1) {}

    clearPersistentNotification(...ids: number[]) {
        this.notificationService.clearPersistentNotification(...ids);
    }

    editPersistentnotification(id: number, options: Partial<PersistentNotificationOptions>) {
        this.notificationService.editPersistentNotification(id, options);
    }

    insertPersistentNotification(options: PersistentNotificationOptions) {
        return this.notificationService.insertPersistentNotification(options);
    }

    warning(message: string) {
        this.notificationService.operationExecutedWithWarning(message);
    }

    success(message: string) {
        this.notificationService.operationExecutedWithSuccess(message);
    }

    error(message: string) {
        this.notificationService.operationFailed(message);
    }
}
